import { EntityRefLink, useEntity } from '@backstage/plugin-catalog-react';
import { Content, InfoCard } from '@backstage/core-components';
import { Grid, Typography } from '@material-ui/core';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { componentTranslationRef } from '../../translation/component/component';

export const ComponentForm = () => {
    const { entity } = useEntity();
    const { t } = useTranslationRef(componentTranslationRef);

    // Extract relevant fields from the project entity
    const componentName = entity.metadata.name;

    const {
        system,
        type,
        lifecycle,
        project,
    } = entity.spec ?? {};

    return (
        <Content noPadding>
            <InfoCard title={t('componentForm.title')}>
                <form>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container spacing={3}>

                                {/* Nombre del componente */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('componentTableColumns.name')}</Typography>
                                    <Typography variant="body1">{componentName}</Typography>
                                </Grid>

                                {/* Título */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('componentTableColumns.title')}</Typography>
                                    <Typography variant="body1">{entity.metadata.title || '—'}</Typography>
                                </Grid>

                                {/* Type */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('componentTableColumns.type')}</Typography>
                                    <Typography variant="body1">{type as string || '—'}</Typography>
                                </Grid>

                                {/* Aplicación */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('componentTableColumns.application')}</Typography>
                                    {system ? <EntityRefLink
                                        entityRef={system as string}
                                        defaultKind={'Application'}
                                        defaultNamespace="default"
                                    /> : <Typography variant="body1">
                                        {system as string || '—'}
                                    </Typography>}
                                </Grid>

                                {/* Proyecto */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('componentTableColumns.project')}</Typography>
                                    {project ? <EntityRefLink
                                        entityRef={project as string}
                                        defaultKind={'Project'}
                                        defaultNamespace="default"
                                    /> : <Typography variant="body1">
                                        {project as string || '—'}
                                    </Typography>}
                                </Grid>

                                {/* Lifecycle */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('componentTableColumns.lifecycle')}</Typography>
                                    <Typography variant="body1">{lifecycle as string || '—'}</Typography>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </InfoCard>
        </Content>
    );
};